
import { ApiModule } from '@api/src/ApiModule'

/**
 * Define Validation Rules
 */
const rules = {
  writing_rate: () => { return false }
}

/**
 * Validation Class
 *
 *
 * Testing Various Syntax
 * ------------------------------------------
 * i.e. -> NA
 *   const check = Ambition.Validate.setValue('Testing...').check({ rule: 'writing_rate' })
 *
 * i.e. -> NA
 *   const v = Ambition.Validate
 *   const check = v.setValue('Testing...').check({ rule: 'writing_rate' })
 *
 * i.e. -> Chosen Method
 *   const v = new Ambition.Validate({ rule: 'writing_rate' })
 *   const check = v.setValue('Testing...').check()
 */
class Validate extends ApiModule {

  constructor({ rule }) {
    super()

    this.rule = rule
  }

  setValue(value) {
    this.value = value
    return this
  }

  check() {
    return `Rule: ${this.rule} / Value: ${this.value}`
  }
}

// Function
// export function Validate(e) { return new Validator(e) }

export { Validate }
